/*
  Code below is based on knowledgecode jQuery.param:
  https://github.com/knowledgecode/jquery-param/blob/master/jquery-param.js
 */
'use strict';
const JsonToQuery = (object, skipEncoding = false) => {

  let s = [],
    rbracket = /\[\]$/,
    isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    },
    add = function (k, v) {
      v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
      s[s.length] = skipEncoding ? k + '=' + v : encodeURIComponent(k) + '=' + encodeURIComponent(v);
    },
    buildParams = function (prefix, obj) {
      let i, len, key;

      if (prefix) {
        if (isArray(obj)) {
          for (i = 0, len = obj.length; i < len; i++) {
            if (rbracket.test(prefix)) {
              add(prefix, obj[i]);
            } else {
              buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
            }
          }
        } else if (obj && String(obj) === '[object Object]') {
          for (key in obj) {
            buildParams(prefix + '[' + key + ']', obj[key]);
          }
        } else {
          add(prefix, obj);
        }
      } else if (isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          add(obj[i].name, obj[i].value);
        }
      } else {
        for (key in obj) {
          buildParams(key, obj[key]);
        }
      }
      return s;
    }
  return buildParams('', object).join('&').replace(/%20/g, '+');
}

export default JsonToQuery
